/**
 * UID-46 — small readers over a `LibrarySourceable.configAttributes` bag
 * (`{ [key: string]: unknown }` on the real generated contract, C0's
 * `EditPartConfigRequest`). Extracted from `EditConfigurationModal.tsx`
 * (UID-163/C3) so `PartsBulkConfigureModal.tsx`'s mixed-existing-values
 * advisory (AC3) reads a selected row's stored config through the SAME
 * defensive readers as the row-level editor, rather than a second,
 * independently-drifting copy.
 */
export function readStringAttr(
  attrs: Readonly<Record<string, unknown>> | undefined,
  key: string,
): string {
  const value = attrs?.[key]
  return typeof value === 'string' ? value : ''
}

export function readNumberAttr(
  attrs: Readonly<Record<string, unknown>> | undefined,
  key: string,
): number | null {
  const value = attrs?.[key]
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function readStringListAttr(
  attrs: Readonly<Record<string, unknown>> | undefined,
  key: string,
): readonly string[] {
  const value = attrs?.[key]
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : []
}

/** UID-434/WS-D — RFQ's `customInspection` (a boolean ROUTING state, per
 * `RfqLineSpecification.customInspection`'s own doc comment) is the first
 * boolean-shaped attribute any `PartConfiguratorSubject.configAttributes`
 * bag needs to seed. Absent/non-boolean reads as `false`, same defensive
 * posture as the other readers above. */
export function readBooleanAttr(
  attrs: Readonly<Record<string, unknown>> | undefined,
  key: string,
): boolean {
  return attrs?.[key] === true
}
